<template>
  <div>
    <admin-header></admin-header>
    <div class="wrap_content">
      <slot />
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<script>
import AdminHeader from "@/components/be/AdminHeader";
import AdminFooter from "@/components/be/AdminFooter";
export default {
  components: {
    AdminHeader,
    AdminFooter
  }
};
</script>

<style  src="../assets/css/admin.css">
</style>